module.exports = __webpack_public_path__ + "img/Barakov-full.55a2386f.png";